import React, { useState } from "react";
import { CardBody, TabContent, TabPane } from "reactstrap";
import SubscriberChart from "./SubscriberChart";
import SalesAmountChart from "./SalesAmountChart";
import TotalSalesChart from "./TotalSalesChart";
import MembershipTrendsChart from "./MembershipTrendsChart";

const ChartTabs = ({ dailyStats }) => {
  const [activeTab, setActiveTab] = useState("1");

  const baseTabStyle = {
    backgroundColor: "#e9ecef",
    color: "#495057",
    borderRadius: "4px",
    marginRight: "8px",
    padding: "8px 16px",
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    fontWeight: "normal",
  };

  const activeTabStyle = {
    ...baseTabStyle,
    backgroundColor: "#343a40",
    color: "#ffffff",
    fontWeight: "bold",
  };

  return (
    <CardBody>
      <div
        className="mb-4"
        style={{
          display: "flex",
          justifyContent: "center",
        }}
      >
        <div
          onClick={() => setActiveTab("1")}
          style={activeTab === "1" ? activeTabStyle : baseTabStyle}
        >
          <i className="fas fa-users mr-2"></i> Subscription Status
        </div>
        <div
          onClick={() => setActiveTab("2")}
          style={activeTab === "2" ? activeTabStyle : baseTabStyle}
        >
          <i className="fas fa-chart-line mr-2"></i> Sales Statistics
        </div>
        <div
          onClick={() => setActiveTab("3")}
          style={activeTab === "3" ? activeTabStyle : baseTabStyle}
        >
          <i className="fas fa-dollar-sign mr-2"></i> Total Sales
        </div>
        <div
          onClick={() => setActiveTab("4")}
          style={activeTab === "4" ? activeTabStyle : baseTabStyle}
        >
          <i className="fas fa-dollar-sign mr-2"></i> Membership Trends
        </div>
      </div>

      <TabContent activeTab={activeTab}>
        <TabPane tabId="1">
          <SubscriberChart data={dailyStats} />
        </TabPane>
        <TabPane tabId="2">
          <SalesAmountChart data={dailyStats} />
        </TabPane>
        <TabPane tabId="3">
          <TotalSalesChart data={dailyStats} />
        </TabPane>
        <TabPane tabId="4">
          <MembershipTrendsChart data={dailyStats} />
        </TabPane>
      </TabContent>
    </CardBody>
  );
};

export default ChartTabs;
